module.exports = __webpack_public_path__ + "static/img/为什么选择我们白板.fb583d6b.png";